import { render, staticRenderFns } from "./RecommendEdit.vue?vue&type=template&id=fee27490&scoped=true&"
import script from "./RecommendEdit.vue?vue&type=script&lang=js&"
export * from "./RecommendEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecommendEdit.vue?vue&type=style&index=0&id=fee27490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee27490",
  null
  
)

export default component.exports